import { render, staticRenderFns } from "./ImageTextSettings.vue?vue&type=template&id=042a490a&"
import script from "./ImageTextSettings.vue?vue&type=script&lang=js&"
export * from "./ImageTextSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports